import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxPaginationModule } from 'ngx-pagination';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { NgxMaskModule } from 'ngx-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { MatPaginatorModule } from '@angular/material/paginator';

import { CustomerAgreementRoutingModule } from './customer-agreement-routing.module';
import { CustomerAgreementComponent } from './customer-agreement.component';
import { CustomerAgreementListComponent } from './customer-agreement-list/customer-agreement-list.component';
import { CustomerAgreementPdfComponent } from './customer-agreement-pdf/customer-agreement-pdf.component';
import { CustomerAgreementDetailsComponent } from './customer-agreement-details/customer-agreement-details.component';
import { CreateCustomerAgreementComponent } from './create-customer-agreement/create-customer-agreement.component';


@NgModule({
  declarations: [
    CustomerAgreementComponent,
    CustomerAgreementListComponent,
    CustomerAgreementPdfComponent,
    CustomerAgreementDetailsComponent,
    CreateCustomerAgreementComponent
  ],
  imports: [
    CommonModule,
    CustomerAgreementRoutingModule,
    ListModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FurySharedModule,
    MatSelectModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    MatTableModule,
    MatDialogModule,
    NgxPaginationModule,
    MatPaginatorModule
  ]
})
export class CustomerAgreementModule { }
